import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import getScheduleAction from 'helpers/getScheduleAction';
import shortenText from 'helpers/shortenText';
import { deepExtract } from 'helpers/deep';
import SchedulesDeriver from 'derivers/Schedules';
import { NextCycleMessage } from 'features/InventoryDetail/Schedule/Messages';
import { SEARCH } from 'constants/filter-sets';
import { DESCRIPTION_LENGTH, RESULT_TYPES } from '../Search.constants';
import { VenueItem } from './VenueItem';
import { TrackedScheduleItem } from './TrackedScheduleItem';
import css from '../Search.scss';

const { SCHEDULE } = RESULT_TYPES;

class SearchResultsList extends Component {
  componentDidMount() {
    if (__CLIENT__ || __TEST__) {
      window.addEventListener('message', this.handleMessage);
    }
  }

  componentWillUnmount() {
    if (__CLIENT__ || __TEST__) {
      window.removeEventListener('message', this.handleMessage);
    }
  }

  handleMessage = event => {
    const { eventName } = event.data;
    if (eventName === 'resIframe:onReservationUpdate') {
      this.props.reservationStatusChanged();
    }
  };

  renderScheduleItem = (schedule, index) => {
    const { isMobile, memberStatus, currentVertical, resultType, searchId } = this.props;

    const availabilityData = SchedulesDeriver.availabilityData(schedule);
    const klass = schedule.class || {};
    const teacher = schedule.teacher || {};
    const venue = schedule.venue || {};
    const reason = !availabilityData.isTopUp
      ? availabilityData.creditsReason || availabilityData.reasonCannotReserve
      : null;
    // When there is a message, there are insufficient ratings
    // therefore we should show the venue's ratings
    // TODO, move this logic into StarRating in SEARCH-3897
    const venueRating = deepExtract('ratings.message', venue) ? {} : venue.ratings;
    const ratings = deepExtract('ratings.mean', klass) ? klass.ratings : venueRating;

    return (
      <TrackedScheduleItem
        isMobile={isMobile}
        activities={klass.activities}
        availabilityLabel={availabilityData.label}
        availableToReserve={availabilityData.availableToReserve}
        callToAction={getScheduleAction(memberStatus, schedule)}
        classAlias={klass.alias}
        classId={klass.id}
        credits={schedule.availability && schedule.availability.credits}
        duration={schedule.display_duration}
        id={schedule.id}
        isPremium={availabilityData.isPremium}
        isReserved={availabilityData.isReserved}
        name={klass.name}
        neighborhood={venue.location && venue.location.name}
        memberStatus={memberStatus}
        startTime={schedule.starttime}
        ratingsCount={ratings.display_total}
        ratingsMean={ratings.mean}
        reason={reason}
        resultType={resultType}
        teacherName={teacher.name}
        timeZone={venue.tz}
        venueAlias={venue.alias}
        venueName={venue.name}
        venueId={venue.id}
        venueSubtitle={venue.subtitle}
        schedule={schedule}
        pageType={SEARCH}
        position={index}
        vertical={currentVertical}
        searchId={searchId}
        availabilityData={availabilityData}
      />
    );
  };

  renderVenueItem = venue => {
    const { searchId } = this.props;
    const descriptionLength = this.props.shouldShowShortDescription
      ? DESCRIPTION_LENGTH.SHORT
      : DESCRIPTION_LENGTH.DEFAULT;
    return <VenueItem {...venue} description={shortenText(venue.description, descriptionLength)} searchId={searchId} />;
  };

  renderResultsListItem = (result, idx) => {
    const { resultType, onListItemEnter, onListItemLeave } = this.props;

    const venueId = resultType === SCHEDULE ? result.venue.id : result.id;
    return (
      <li
        className={css.Search__results__list__item}
        key={result.id}
        onMouseEnter={onListItemEnter.bind(null, venueId)}
        onMouseLeave={onListItemLeave}>
        {resultType === SCHEDULE ? this.renderScheduleItem(result, idx) : this.renderVenueItem(result)}
      </li>
    );
  };

  render() {
    const { isViewingNextCycle, resultType, results } = this.props;

    return (
      <Fragment>
        {isViewingNextCycle && resultType === SCHEDULE && <NextCycleMessage />}
        <ul>{results.map(this.renderResultsListItem)}</ul>
      </Fragment>
    );
  }
}

SearchResultsList.propTypes = {
  currentVertical: PropTypes.string.isRequired,
  searchId: PropTypes.string,
  isMobile: PropTypes.bool,
  isViewingNextCycle: PropTypes.bool,
  memberStatus: PropTypes.string,
  reservationStatusChanged: PropTypes.func,
  results: PropTypes.arrayOf(PropTypes.object),
  resultType: PropTypes.oneOf(Object.keys(RESULT_TYPES)),
  showModal: PropTypes.func,
  onListItemEnter: PropTypes.func,
  onListItemLeave: PropTypes.func,
  shouldShowShortDescription: PropTypes.bool,
};

export { SearchResultsList };
